/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { VendorListModel } from '@well/domain';

@Injectable({ providedIn: 'root' })
export class ContactValidationService {
  messageService = inject(MessageService);
  translateService = inject(TranslateService);

  isCurrentContactSelected(selectedContacts: { [key: string]: string[] }): boolean {
    return '' in selectedContacts && selectedContacts[''].length > 0;
  }

  isCustomerContactSelected(customerUuid: string, selectedContacts: { [key: string]: string[] }): boolean {
    return customerUuid in selectedContacts && selectedContacts[customerUuid].length > 0;
  }

  isVendorContactSelected(vendor: VendorListModel, selectedContacts: { [key: string]: string[] }): boolean {
    const serviceProviderUuid = vendor.serviceProviderUuid;
    return serviceProviderUuid in selectedContacts && selectedContacts[serviceProviderUuid].length > 0;
  }

  areAllVendorContactsSelected(vendors: VendorListModel[], selectedContacts: { [key: string]: string[] }): boolean {
    return vendors.every((vendor: VendorListModel) => {
      const serviceProviderUuid = vendor.serviceProviderUuid;
      return serviceProviderUuid in selectedContacts && selectedContacts[serviceProviderUuid].length > 0;
    });
  }

  showErrorMessage() {
    this.messageService.add({
      key: 'global-notification',
      severity: 'error',
      life: 8000,
      summary: this.translateService.instant('delivery-app.error.validationError'),
      detail: this.translateService.instant('delivery-app.error.selectAtLeastOneContactPerEntity'),
    });
  }
}
